import { render, staticRenderFns } from "./UpdateApp.vue?vue&type=template&id=9b776210&scoped=true&"
import script from "./UpdateApp.vue?vue&type=script&lang=js&"
export * from "./UpdateApp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateApp.vue?vue&type=style&index=0&id=9b776210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b776210",
  null
  
)

component.options.__file = "UpdateApp.vue"
export default component.exports